import Model from "../_model";

export default class ReferenceModel extends Model {
	constructor(provider) {
		super(provider, "references");
	}
	filter(params = {}, { onSuccess, onFail } = {}) {
		return super.filter({ params, onSuccess, onFail });
	}
	find(id, { onSuccess, onFail } = {}) {
		return super.find({ id, onSuccess, onFail });
	}
	create(reference, { onSuccess, onFail } = {}) {
		return super.create(reference, { onSuccess, onFail });
	}
	update(reference, { onSuccess, onFail } = {}) {
		const id = reference.id || reference._id;
		return super.update(reference, { id, onSuccess, onFail });
	}
	delete(id, { onSuccess, onFail } = {}) {
		return super.delete({ id, onSuccess, onFail });
	}
}
